
// applyHeight();
// window.addEventListener('resize', function(event) {
//     applyHeight();
// }, true);
// function applyHeight(){
//     if(window.innerWidth >= 1200){
//         let nav=document.querySelector('nav').offsetHeight;
//         document.querySelector('.template-index main').style.marginTop=`-${nav+1}px`
//     }else{
//         document.querySelector('.template-index main').style.marginTop=`0px`
//     }
// }

document.querySelectorAll('[data-index-type-coffee]').forEach(ele => {
   ele.addEventListener('click',function (event) {
        let coffee_type=event.target.closest('[data-index-type-coffee]').getAttribute('data-index-type-coffee') 
        localStorage.setItem('coffee_type', coffee_type);
        window.location.href='/pages/subscription-funnel';
   });
}); 
// document.querySelector('[data-trigger-video]').click();
